
// import { Save, X, Settings } from "lucide-react";
// import { Button } from "@/components/ui/button";

// interface ProfileActionsProps {
//   isEditing: boolean;
//   checkFormValidity: () => boolean;
//   // handleSave: () => void;
//   setIsEditing: (value: boolean) => void;
// }

// export const ProfileActions = ({ 
//   isEditing, 
//   checkFormValidity, 
//   // handleSave, 
//   setIsEditing 
// }: ProfileActionsProps) => {
//   return (
//     <>
//       {isEditing ? (
//         <div className="flex gap-2">
//           <Button 
//             // onClick={handleSave} 
//             className="flex-1" 
//             variant="default"
//             disabled={!checkFormValidity()}
//           >
//             <Save className="w-4 h-4 mr-2" />
//             Save
//           </Button>
//           <Button onClick={() => setIsEditing(false)} variant="outline" className="flex-1">
//             <X className="w-4 h-4 mr-2" />
//             Cancel
//           </Button>
//         </div>
//       ) : (
//         <Button className="w-full" variant="outline" onClick={() => setIsEditing(true)}>
//           <Settings className="w-4 h-4 mr-2" />
//           Edit Profile
//         </Button>
//       )}
//     </>
//   );
// };



import { Settings } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ProfileActionsProps {
  isEditing: boolean;
  checkFormValidity: () => boolean;
  handleSave: () => void;
  setIsEditing: (value: boolean) => void;
  handleCancel?: () => void;
}

export const ProfileActions = ({
  isEditing,
  checkFormValidity,
  handleSave,
  setIsEditing,
  handleCancel
}: ProfileActionsProps) => {
  return (
    <>
      {isEditing ? (
        <div className="flex gap-2">
          <Button
          onClick={handleSave}
            className="flex-1"
            variant="default"
            disabled={!checkFormValidity()}
          >
            Save
          </Button>
          <Button
            onClick={() => {
              setIsEditing(false)
              handleCancel()
            }}
            variant="outline"
            className="flex-1"
          >
            Cancel
          </Button>
        </div>
      ) : (
        <Button
          className="w-full"
          variant="outline"
          onClick={() => setIsEditing(true)}
        >
          <Settings className="w-4 h-4 mr-2" />
          Edit Profile
        </Button>
      )}
    </>
  );
};